import React from 'react';
import { useAppSelector } from '../../store';
import { baseDarkTheme, baselightTheme } from '../../theme/DefaultColors';

export default function useColor() {
  const activeMode = useAppSelector((state) => state.customizer.activeMode);
  const defaultTheme = activeMode === 'dark' ? baseDarkTheme : baselightTheme;

  return defaultTheme.palette;
}
